import React from 'react'
import styled, { css } from 'styled-components'

const StyledContainer = styled.span`
	display: flex;
	align-items: center;
	width: ${({ active }) => active ? '90px' : '20px'};
	padding-left: ${({ active }) => active ? '10px' : 'unset'};
	transition: all 0.3s;
	height: 36px;
	position: relative;
	&:not(:last-of-type) {
		margin-right: 10px;
	}
`

const StyledButton = styled.button`
	width: 20px;
	height: 20px;
	padding: 0;
	border-radius: 1px;
	border: 1px solid #c3c3c3;
	color: #cdcdcd;
	position: relative;
	z-index: 10;
	transition: all 0.3s;
	${({ active }) => active && css`
		background-color: #3c445a;
		border-color: transparent;
		color: #fff;
	`}
`

const StyledInput = styled.input`
	visibility: hidden;
	width: 0;
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	padding-left: 0;
	padding-right: 0;
	transition: all 0.3s;
	${({ active }) => active && css`
		visibility: visible;
		width: 100%;
		padding-left: 40px !important;
		padding-right: 12px !important;
	`}
`

const Operator = ({ active, text, value, onChange, onClick }) => {
	return (
		<StyledContainer active={active}>
			<StyledButton active={active} onClick={onClick}>
				{text}
			</StyledButton>
			{active &&
				<StyledInput
					active={active}
					value={value}
					type='text'
					autoFocus={true}
					onChange={onChange}
				/>
			}
		</StyledContainer>
	)
}

export default Operator
